/* eslint-disable */
// ============================================================
//  UI - Composants UI partagés du projet HorseConnex
// ============================================================

import { useState, useEffect, useRef } from "react";
import { supabase, trackGuestEvent } from "./supabase";
import {
  CAT_COLOR,
  COUNTRIES,
  HORSE_BREEDS,
  HORSE_DISCIPLINES,
  HORSE_SEX,
  HORSE_LEVELS,
  HORSE_AGE_RANGES,
  CATEGORIES,
  LOGO,
} from "./constants";
import { validatePassword, useLang } from "./utils";
import { signInWithGoogle } from "./native-google";

// === Style global ===
export const G = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800;900&family=DM+Sans:wght@300;400;500;600&display=swap');
    *{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent;}
    :root{
      --red:#C8001A;--dark:#1A1A2E;--dark2:#0D0D1A;
      --bg:#F2EEE8;--card:#fff;--text:#1A1A2E;
      --muted:#7A7A8C;--border:#E0DBD4;
      --sh:0 2px 10px rgba(0,0,0,.07);
      --fh:'Barlow Condensed',sans-serif;
      --fb:'DM Sans',sans-serif;
    }
    html,body{background:var(--bg);font-family:var(--fb);color:var(--text);}
    input,textarea,select,button{font-family:var(--fb);outline:none;}
    ::-webkit-scrollbar{display:none;}
    @keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
    @keyframes pls{0%,100%{opacity:.4;transform:scale(.7)}50%{opacity:1;transform:scale(1.1)}}
    @keyframes spin{to{transform:rotate(360deg)}}
    @keyframes slideUp{from{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}
    @keyframes fadeIn{from{opacity:0}to{opacity:1}}
    .fu{animation:fadeUp .28s ease both}
    .fu1{animation:fadeUp .28s .07s ease both}
    .fu2{animation:fadeUp .28s .14s ease both}
    .fu3{animation:fadeUp .28s .21s ease both}
    input:focus,textarea:focus{border-color:var(--red)!important;}
    button:active{transform:scale(.97);}

    /* ==========================================================
       Thème HorseConnex Light (activé via data-theme="hc-light").
       Décision design : fond global en dégradé rouge HC → noir
       profond (cf. THEMES.hc-light.bg dans theme.js). Le pattern
       visuel reste hero-dark / cards-blanc :
         - le gradient rouge→noir entoure tous les écrans,
         - les cards et le contenu intermédiaire sont déjà sur
           fonds blancs opaques (#fff) avec texte foncé (color:
           var(--text)) → naturellement lisibles sur fond sombre,
         - les CTAs, heros, badges colorés restent intacts.
       Du coup, on n a quasiment rien à override en CSS — juste
       cacher les NightSparkles qui seraient redondantes avec
       le gradient marqué.
       ========================================================== */
    :root[data-theme="hc-light"] [style*="position: absolute"][style*="inset: 0px"][style*="pointer-events: none"]{
      display:none!important;
    }
  `}</style>
);

// ===============================================================


// === I ===
export const I = {
  home:     (p)=><svg {...sv(p)}><path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/><path d="M9 21V12h6v9"/></svg>,
  list:     (p)=><svg {...sv(p)}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>,
  shop:     (p)=><svg {...sv(p)}><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>,
  map:      (p)=><svg {...sv(p)}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  msg:      (p)=><svg {...sv(p)}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
  user:     (p)=><svg {...sv(p)}><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  horses:   (p)=><svg {...sv(p)}><path d="M4 16c0-4 2-7 5-8.5L11 6l1-2h3l1 2 2 1c1 1 2 2.5 2 4v1l-1 1h-2l-1 2v4h-3v-4l-2-1-2 1v4H6v-4l-1-1z"/></svg>,
  stables:  (p)=><svg {...sv(p)}><path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/><path d="M9 21V12h6v9"/><path d="M9 12a3 3 0 006 0"/></svg>,
  lessons:  (p)=><svg {...sv(p)}><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>,
  events:   (p)=><svg {...sv(p)}><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
  care:     (p)=><svg {...sv(p)}><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  jobs:     (p)=><svg {...sv(p)}><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
  estate:   (p)=><svg {...sv(p)}><path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/><path d="M9 21V12h6v9"/></svg>,
  pension:  (p)=><svg {...sv(p)}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
  transport:(p)=><svg {...sv(p)}><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  gear:     (p)=><svg {...sv(p)}><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>,
  all:      (p)=><svg {...sv(p)}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  search:   (p)=><svg {...sv(p)}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  close:    (p)=><svg {...sv(p)}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  back:     (p)=><svg {...sv(p)}><polyline points="15 18 9 12 15 6"/></svg>,
  chevron:  (p)=><svg {...sv(p)}><polyline points="9 18 15 12 9 6"/></svg>,
  star:     ({s=14,c="#F5A623"})=><svg width={s} height={s} viewBox="0 0 24 24" fill={c} stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>,
  pin:      (p)=><svg {...sv(p)}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  phone:    (p)=><svg {...sv(p)}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 10.5a19.79 19.79 0 01-3.07-8.67A2 2 0 012.88 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>,
  mail:     (p)=><svg {...sv(p)}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  send:     (p)=><svg {...sv(p)}><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  plus:     (p)=><svg {...sv(p)}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  edit:     (p)=><svg {...sv(p)}><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  heart:    (p)=><svg {...sv(p)}><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>,
  bell:     (p)=><svg {...sv(p)}><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>,
  lock:     (p)=><svg {...sv(p)}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
  globe:    (p)=><svg {...sv(p)}><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>,
  help:     (p)=><svg {...sv(p)}><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  logout:   (p)=><svg {...sv(p)}><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  check:    (p)=><svg {...sv(p)}><polyline points="20 6 9 17 4 12"/></svg>,
  camera:   (p)=><svg {...sv(p)}><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  photo:    (p)=><svg {...sv(p)}><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="3"/><line x1="18" y1="3" x2="18" y2="8"/><line x1="15.5" y1="5.5" x2="20.5" y2="5.5"/></svg>,
  photo:    (p)=><svg {...sv(p)}><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="3"/><line x1="18" y1="3" x2="18" y2="8"/><line x1="15.5" y1="5.5" x2="20.5" y2="5.5"/></svg>,
  notif:    (p)=><svg {...sv(p)}><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>,
  shield:   (p)=><svg {...sv(p)}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  stages:   (p)=><svg {...sv(p)}><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>,
  rental:   (p)=><svg {...sv(p)}><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
  calendar: (p)=><svg {...sv(p)}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  share:    (p)=><svg {...sv(p)}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  flag:     (p)=><svg {...sv(p)}><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>,
  alert:    (p)=><svg {...sv(p)}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  crown:    (p)=><svg {...sv(p)}><path d="M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7z"/><line x1="4" y1="20" x2="20" y2="20"/></svg>,
  filter2:  (p)=><svg {...sv(p)}><line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="11" y1="18" x2="13" y2="18"/></svg>,
  tarifs:   (p)=><svg {...sv(p)}><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>,
  gite:     (p)=><svg {...sv(p)}><path d="M2 20v-8a2 2 0 012-2h16a2 2 0 012 2v8"/><path d="M4 10V6a2 2 0 012-2h12a2 2 0 012 2v4"/><path d="M2 18h20"/><path d="M8 10V8h8v2"/></svg>,
};



// === sv ===
export function sv({s=20,c="currentColor",sw=1.7}){
  return {width:s,height:s,viewBox:"0 0 24 24",fill:"none",stroke:c,strokeWidth:sw,strokeLinecap:"round",strokeLinejoin:"round"};
}


// === CIcon ===
export const CIcon = ({name,s=18,c="currentColor",sw=1.7}) => {
  const Comp = I[name];
  return Comp ? <Comp s={s} c={c} sw={sw}/> : null;
};



// === Btn ===
export const Btn = ({children,onClick,ghost=false,dark=false,small=false,disabled=false,sx={}}) => (
  <button
    onClick={disabled?undefined:onClick}
    style={{
      background: disabled?"#C8C8C8":ghost?"transparent":dark?"var(--dark)":"var(--red)",
      color: ghost?"var(--red)":"#fff",
      border:`2px solid ${disabled?"#C8C8C8":ghost?"var(--red)":dark?"var(--dark)":"var(--red)"}`,
      borderRadius:11, padding:small?"8px 16px":"13px 20px",
      fontSize:small?12:15, fontWeight:700, fontFamily:"var(--fh)",
      letterSpacing:.4, width:"100%", cursor:disabled?"not-allowed":"pointer",
      transition:"opacity .15s", opacity:disabled?.55:1, ...sx,
    }}
  >{children}</button>
);



// === Field ===
export const Field = ({label,placeholder,type="text",icon,value="",onChange,rows,required,showStrength,autoComplete,inputMode,name,pattern,min,max,step,dark=false,...rest}) => {
  const [showPwd, setShowPwd] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword && showPwd ? "text" : type;
  const rightPadding = isPassword ? 42 : 14;
  return (
  <div>
    {label&&<div style={{fontSize:10,fontWeight:700,color:dark?"rgba(255,255,255,.85)":"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:5}}>
      {label}{required&&<span style={{color:dark?"#ff8a9b":"var(--red)",marginLeft:2}}>*</span>}
    </div>}
    <div style={{position:"relative"}}>
      {icon&&<span style={{position:"absolute",left:11,top:rows?"13px":"50%",transform:rows?"none":"translateY(-50%)",zIndex:1,display:"flex"}}>
        <CIcon name={icon} s={15} c="var(--muted)"/>
      </span>}
      {rows
        ? <textarea placeholder={placeholder} value={value} onChange={onChange} rows={rows} autoComplete={autoComplete} name={name} {...rest}
            style={{width:"100%",padding:icon?"11px 12px 11px 36px":"11px 14px",background:"#fff",border:"1.5px solid var(--border)",borderRadius:10,fontSize:13,color:"var(--text)",resize:"none",fontFamily:"var(--fb)"}}/>
        : <input type={inputType} placeholder={placeholder} value={value} onChange={onChange} autoComplete={autoComplete} inputMode={inputMode} name={name} pattern={pattern} min={min} max={max} step={step} {...rest}
            style={{width:"100%",padding:icon?`11px ${rightPadding}px 11px 36px`:`11px ${rightPadding}px 11px 14px`,background:"#fff",border:"1.5px solid var(--border)",borderRadius:10,fontSize:13,color:"var(--text)",boxSizing:"border-box"}}/>
      }
      {isPassword && (
        <button type="button" onClick={()=>setShowPwd(!showPwd)} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",fontSize:18,padding:4,color:"var(--muted)"}} aria-label={showPwd?"Masquer":"Afficher"}>
          {showPwd ? "🙈" : "👁️"}
        </button>
      )}
    </div>
    {isPassword && showStrength && <PasswordStrength pwd={value}/>}
  </div>
  );
};



// === Chk ===
// `dark` : adapte le label pour les fonds sombres (texte clair + border claire si décoché).
export const Chk = ({on,toggle,label,dark=false}) => (
  <div onClick={toggle} style={{display:"flex",alignItems:"flex-start",gap:10,cursor:"pointer"}}>
    <div style={{width:20,height:20,borderRadius:5,border:`2px solid ${on?"var(--red)":(dark?"rgba(255,255,255,.35)":"var(--border)")}`,background:on?"var(--red)":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all .15s",marginTop:1}}>
      {on&&<CIcon name="check" s={11} c="#fff" sw={2.5}/>}
    </div>
    {label&&<span style={{fontSize:12.5,color:dark?"rgba(255,255,255,.9)":"var(--text)",lineHeight:1.5}}>{label}</span>}
  </div>
);

// === ContactSection : section "Comment être contacté" pour la création d'annonce ===
// Logique :
//  - La messagerie interne est TOUJOURS active (affichée, non désactivable)
//  - Case "Contacter par téléphone" (oui/non) + champ téléphone si activé
//  - Case "Contacter par email" (oui/non)
//  - Case raccourci "Uniquement par messagerie interne" : force tel+email à non
//  - Message explicatif de sécurité avec case "ne plus afficher"
export const ContactSection = ({form, up, lang = "fr"}) => {
  const t = useLang(lang);
  const [showInfo, setShowInfo] = useState(true);
  const onlyMessaging = form.contactPhone === false && !form.contactEmail;

  const toggleOnlyMessaging = () => {
    if (onlyMessaging) {
      // Si déjà "que messagerie", on réactive le téléphone par défaut
      up("contactPhone", true);
    } else {
      // On force tel + email à non
      up("contactPhone", false);
      up("contactEmail", false);
    }
  };

  return (
    <div style={{background:"rgba(200,0,26,.04)",border:"1px solid rgba(200,0,26,.15)",borderRadius:10,padding:"12px 14px",marginTop:4}}>
      <div style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,.65)",marginBottom:10,letterSpacing:0.5}}>{t.csHowContact}</div>

      {/* Messagerie interne - toujours active */}
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12,padding:"8px 10px",background:"rgba(16,185,129,.13)",borderRadius:8,border:"1px solid rgba(16,185,129,.32)"}}>
        <CIcon name="msg" s={16} c="#34d399"/>
        <span style={{fontSize:12,color:"#34d399",fontWeight:600}}>{t.csInternalMessaging}</span>
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <Chk dark on={form.contactPhone!==false} toggle={()=>up("contactPhone",form.contactPhone===false)} label={t.csContactPhone}/>
        {form.contactPhone!==false && (
          <Field dark label={t.phone} placeholder="+41 00 000 00 00" type="tel" icon="phone" value={form.phone||""} onChange={e=>up("phone",e.target.value)}/>
        )}
        <Chk dark on={form.contactEmail||false} toggle={()=>up("contactEmail",!form.contactEmail)} label={t.csContactEmail}/>
        <div style={{borderTop:"1px solid rgba(255,255,255,.14)",paddingTop:10,marginTop:2}}>
          <Chk dark on={onlyMessaging} toggle={toggleOnlyMessaging} label={t.csOnlyMessaging}/>
        </div>
      </div>

      {/* Message explicatif sécurité */}
      {showInfo && (
        <div style={{marginTop:12,padding:"10px 12px",background:"rgba(255,255,255,.06)",borderRadius:8,border:"1px solid rgba(255,255,255,.14)"}}>
          <div style={{fontSize:11,color:"rgba(255,255,255,.6)",lineHeight:1.6}}>
            {t.csSecurityInfo}
          </div>
          <div onClick={()=>setShowInfo(false)} style={{fontSize:11,color:"#ff8a9b",fontWeight:600,marginTop:8,cursor:"pointer"}}>{t.csHideMessage}</div>
        </div>
      )}
    </div>
  );
};



// === Toast ===
export const Toast = ({msg}) => (
  <div style={{
    position:"fixed",top:56,left:"50%",transform:"translateX(-50%)",
    background:msg.type==="error"?"var(--red)":msg.type==="warn"?"#D4720A":"var(--dark)",
    color:"#fff",padding:"10px 18px",borderRadius:22,fontSize:12.5,fontWeight:600,
    zIndex:9999,boxShadow:"0 4px 16px rgba(0,0,0,.25)",display:"flex",alignItems:"center",
    gap:8,animation:"fadeUp .25s ease",whiteSpace:"normal",maxWidth:"88%",lineHeight:1.4,
  }}>
    <span style={{fontSize:14,flexShrink:0}}>{msg.type==="success"?"✓":msg.type==="error"?"✕":"ℹ"}</span>
    {msg.text}
  </div>
);



// === Modal ===
export const Modal = ({children,onClose}) => (
  <div onClick={e=>e.target===e.currentTarget&&onClose()} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:500,display:"flex",alignItems:"flex-end",justifyContent:"center",animation:"fadeIn .2s"}}>
    <div style={{background:"#fff",color:"var(--text)",borderRadius:"20px 20px 0 0",padding:"20px 20px 28px",width:"100%",maxWidth:430,animation:"slideUp .28s ease",maxHeight:"85vh",overflowY:"auto"}}>
      {children}
    </div>
  </div>
);

// === SignupPrompt : popup invitant un visiteur (mode découverte) à créer un compte ===
// Affiché quand un invité essaie une action nécessitant un compte (contacter, favori, publier).
export const SignupPrompt = ({onClose, onSignup, onLogin, message, lang = "fr"}) => {
  const t = useLang(lang);
  // Intention invité : ce pop-up ne s'affiche qu'aux non connectés qui voulaient
  // contacter/publier/mettre en favori -> on trace ce "mur" (métrique clé).
  useEffect(() => { trackGuestEvent("guest_wall", lang); }, []);
  const signInGoogle = async () => {
    try {
      await signInWithGoogle();
    } catch (e) {
      alert(t.googleUnavailable || "Connexion Google indisponible pour le moment. Réessaie plus tard.");
    }
  };
  return (
  <Modal onClose={onClose}>
    <div style={{textAlign:"center"}}>
      <div style={{fontSize:40,marginBottom:8}}>🐴</div>
      <div style={{fontSize:19,fontWeight:800,color:"var(--text)",marginBottom:8}}>{t.spTitle}</div>
      <div style={{fontSize:14,color:"var(--muted)",lineHeight:1.6,marginBottom:20,padding:"0 8px"}}>
        {message || t.spDefault}
      </div>
      <button onClick={onSignup} style={{background:"var(--red)",color:"#fff",border:"none",borderRadius:12,padding:"15px 20px",fontSize:16,fontFamily:"var(--fh)",fontWeight:700,cursor:"pointer",width:"100%",marginBottom:10}}>
        {t.spCreateBtn}
      </button>
      <button onClick={signInGoogle} style={{background:"#fff",color:"#1f1f1f",border:"1px solid var(--border)",borderRadius:12,padding:"13px 20px",fontSize:15,fontFamily:"var(--fh)",fontWeight:700,cursor:"pointer",width:"100%",marginBottom:10,display:"flex",alignItems:"center",justifyContent:"center",gap:10}}>
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        {t.continueGoogle || "Continuer avec Google"}
      </button>
      <button onClick={onLogin} style={{background:"transparent",color:"var(--muted)",border:"none",padding:"8px",fontSize:14,fontFamily:"var(--fh)",fontWeight:600,cursor:"pointer",width:"100%"}}>
        {t.spHaveAccount}
      </button>
      <div style={{fontSize:11,color:"var(--muted)",marginTop:12,opacity:.7}}>
        {t.spFooter}
      </div>
    </div>
  </Modal>
  );
};



// === Header ===
// Header glassmorphism dark par défaut (cohérent avec le thème nocturne 2026).
// `bg` accepte toujours une valeur custom pour les cas spécifiques (gradients
// d'écran etc.), mais sans bg le rendu est translucide + blur (style iOS).
export const Header = ({title,onBack,right,bg}) => {
  const isCustomBg = !!bg;
  return (
    <div style={{
      position: "sticky", top: 0, zIndex: 10,
      background: bg || "rgba(13,13,26,.7)",
      backdropFilter: isCustomBg ? "none" : "blur(14px)",
      WebkitBackdropFilter: isCustomBg ? "none" : "blur(14px)",
      borderBottom: isCustomBg ? "none" : "1px solid rgba(255,255,255,.1)",
      padding: "calc(env(safe-area-inset-top, 22px) + 14px) 16px 12px",
      display: "flex", alignItems: "center", gap: 12,
      flexShrink: 0,
    }}>
      {onBack && (
        <button onClick={onBack} style={{
          background: "rgba(255,255,255,.08)",
          border: "1px solid rgba(255,255,255,.12)",
          borderRadius: 10,
          width: 36, height: 36,
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", flexShrink: 0,
          transition: "background .15s",
        }}
        onMouseEnter={e=>e.currentTarget.style.background="rgba(255,255,255,.14)"}
        onMouseLeave={e=>e.currentTarget.style.background="rgba(255,255,255,.08)"}
        >
          <CIcon name="back" s={18} c="#fff"/>
        </button>
      )}
      <div style={{
        fontFamily: "var(--fh)", fontSize: 18, fontWeight: 900,
        color: "#fff", letterSpacing: 0.3,
        flex: 1, lineHeight: 1.1, minWidth: 0,
      }}>{title}</div>
      {right}
    </div>
  );
};



// === AdCard ===
export const AdCard = ({ad,onClick,lang = "fr"}) => {
  const t = useLang(lang);
  const bc = {PRO:"linear-gradient(135deg,#7C3AED,#5B21B6)",TOP:"linear-gradient(135deg,#F5A623,#C4690A)",NEW:"linear-gradient(135deg,#22c55e,#047857)",CDI:"linear-gradient(135deg,#0EA5E9,#0369A1)"};
  return (
    <div onClick={onClick} style={{
      // Gradient subtil (haut-gauche plus clair que bas-droite) qui donne du relief,
      // évite que la card se fonde dans le fond nocturne.
      background:"var(--app-list-card-bg, linear-gradient(135deg, rgba(255,255,255,.12) 0%, rgba(255,255,255,.06) 100%))",
      backdropFilter:"blur(14px)",
      WebkitBackdropFilter:"blur(14px)",
      borderRadius:14, padding:13,
      border:"1px solid var(--app-list-card-border, rgba(255,255,255,.22))",
      cursor:"pointer",
      display:"flex", gap:12, alignItems:"flex-start",
      position:"relative",
      boxShadow:"0 8px 24px rgba(0,0,0,.45), 0 2px 6px rgba(0,0,0,.3), inset 0 1px 0 rgba(255,255,255,.1)",
      transition:"background .15s, border-color .15s, transform .15s",
    }}
    onMouseEnter={e=>{ e.currentTarget.style.background="var(--app-list-card-bg-hover, linear-gradient(135deg, rgba(255,255,255,.18) 0%, rgba(255,255,255,.09) 100%))"; e.currentTarget.style.borderColor="var(--app-list-card-border-hover, rgba(255,255,255,.32))"; }}
    onMouseLeave={e=>{ e.currentTarget.style.background="var(--app-list-card-bg, linear-gradient(135deg, rgba(255,255,255,.12) 0%, rgba(255,255,255,.06) 100%))"; e.currentTarget.style.borderColor="var(--app-list-card-border, rgba(255,255,255,.22))"; }}
    >
      {ad.hot && (
        <div style={{
          position:"absolute", top:-6, right:10,
          background:"var(--app-cta-bg)",
          color:"#fff", fontSize:9, fontWeight:800,
          padding:"2px 8px", borderRadius:20,
          fontFamily:"var(--fh)", letterSpacing:.5,
          boxShadow:"0 4px 12px rgba(200,0,26,.5)",
          zIndex:2,
        }}>🔥 HOT</div>
      )}
      <div style={{
        width:56, height:56, borderRadius:12, flexShrink:0,
        background:(ad.photos && ad.photos[0])
          ? `url(${ad.photos[0]}) center/cover`
          : `linear-gradient(135deg,${CAT_COLOR[ad.cat]||"#C8001A"},${(CAT_COLOR[ad.cat]||"#600")}99)`,
        display:"flex", alignItems:"center", justifyContent:"center",
        position:"relative",
        border:"1px solid rgba(255,255,255,.1)",
      }}>
        {!(ad.photos && ad.photos[0]) && <CIcon name={ad.cat} s={24} c="#fff"/>}
        {ad.photos && ad.photos.length > 1 && (
          <div style={{
            position:"absolute", bottom:3, right:3,
            background:"rgba(0,0,0,.7)", color:"#fff",
            fontSize:9, fontWeight:700,
            padding:"1px 6px", borderRadius:8,
            backdropFilter:"blur(4px)",
          }}>+{ad.photos.length - 1}</div>
        )}
        {ad.video && (
          <div style={{
            position:"absolute", top:3, left:3,
            background:"rgba(0,0,0,.72)", color:"#fff",
            width:16, height:16, borderRadius:5,
            display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:8, backdropFilter:"blur(4px)",
          }}>▶</div>
        )}
      </div>
      <div style={{flex:1, minWidth:0}}>
        <div style={{display:"flex", justifyContent:"space-between", gap:6, alignItems:"flex-start"}}>
          <div style={{
            fontSize:14, fontWeight:700,
            color:"var(--hc-text)", lineHeight:1.3,
            flex:1, fontFamily:"var(--fh)",
          }}>{ad.translations?.[lang]?.title || ad.title}</div>
          {ad.badge && (
            <span style={{
              background:bc[ad.badge] || "var(--app-cta-bg)",
              color:"#fff",
              fontSize:9, fontWeight:800,
              padding:"3px 7px", borderRadius:20,
              letterSpacing:.5, flexShrink:0,
              fontFamily:"var(--fh)",
              boxShadow:"0 2px 8px rgba(0,0,0,.3)",
            }}>{ad.badge}</span>
          )}
        </div>
        <div style={{
          fontSize:18, fontWeight:900,
          color:"var(--hc-accent)",
          fontFamily:"var(--fh)",
          marginTop:2,
          textShadow:"0 0 12px rgba(255,90,110,.25)",
        }}>{ad.price}</div>
        <div style={{
          fontSize:11, color:"var(--hc-text-muted)",
          marginTop:3, display:"flex", alignItems:"center", gap:3,
        }}>
          <CIcon name="pin" s={10} c="var(--hc-text-faint)"/>{ad.loc}
          {ad.verified && <span style={{color:"#34D399", fontWeight:700, marginLeft:4}}>✓ {t.verified}</span>}
        </div>
        <div style={{display:"flex", gap:5, marginTop:6, flexWrap:"wrap", alignItems:"center"}}>
          {/* Badge catégorie — adapté au dark mode */}
          {ad.cat && (() => {
            const catLabels = {
              horses: {emoji:"🐴", label:"Chevaux", color:"#FF5A6E"},
              stables: {emoji:"🏠", label:"Écuries", color:"#94A3B8"},
              lessons: {emoji:"🎓", label:"Cours", color:"#38BDF8"},
              events: {emoji:"🏆", label:"Concours", color:"#FCD34D"},
              stages: {emoji:"📚", label:"Stages", color:"#A78BFA"},
              care: {emoji:"⚕️", label:"Soins", color:"#34D399"},
              photo: {emoji:"📷", label:"Photo/Vidéo", color:"#67E8F9"},
              jobs: {emoji:"💼", label:"Jobs", color:"#FBBF24"},
              estate: {emoji:"🏡", label:"Immobilier", color:"#22D3EE"},
              tarifs: {emoji:"💰", label:"Tarifs", color:"#4ADE80"},
              pension: {emoji:"🐎", label:"Pension", color:"#A3E635"},
              transport: {emoji:"🚛", label:"Transport", color:"#FB7185"},
              gear: {emoji:"🦺", label:"Matériel", color:"#C084FC"},
              rental: {emoji:"🛍️", label:"Location matériel", color:"#2DD4BF"},
              search: {emoji:"🔍", label:"Recherche", color:"#FB923C"},
              kids: {emoji:"🧒", label:"Enfants/Poney", color:"#F472B6"},
              ecurie: {emoji:"🏇", label:"Fiche Écurie", color:"#86EFAC"},
              gite: {emoji:"🛏️", label:"Gîte équestre", color:"#F59E0B"},
            };
            const cat = catLabels[ad.cat];
            if (!cat) return null;
            return (
              <span style={{
                background:`${cat.color}22`,
                color:cat.color,
                border:`1px solid ${cat.color}55`,
                fontSize:10, padding:"2px 7px",
                borderRadius:20, fontWeight:700,
              }}>{cat.emoji} {cat.label}</span>
            );
          })()}
          {ad.tags && ad.tags.map(tag => (
            <span key={tag} style={{
              background:"var(--hc-surface-2)",
              border:"1px solid var(--hc-border)",
              color:"var(--hc-text-muted)",
              fontSize:10, padding:"2px 7px", borderRadius:20,
            }}>{tag}</span>
          ))}
        </div>
        {/* Annonceur (nom + avatar) */}
        {(ad.seller || ad.avatar) && (
          <div style={{
            display:"flex", alignItems:"center", gap:6,
            marginTop:8, paddingTop:8,
            borderTop:"1px solid var(--hc-border)",
          }}>
            {ad.avatar ? (
              <img src={ad.avatar} alt={ad.seller||""} style={{
                width:22, height:22, borderRadius:"50%",
                objectFit:"cover", flexShrink:0,
                border:"1px solid var(--hc-border)",
              }}/>
            ) : (
              <div style={{
                width:22, height:22, borderRadius:"50%",
                background:"var(--app-cta-bg)",
                color:"#fff",
                display:"flex", alignItems:"center", justifyContent:"center",
                fontSize:10, fontWeight:800, fontFamily:"var(--fh)",
                flexShrink:0,
                border:"1px solid rgba(255,255,255,.18)",
              }}>{(ad.seller||"?")[0].toUpperCase()}</div>
            )}
            <span style={{
              fontSize:11, color:"var(--hc-text-muted)",
              fontWeight:600,
              overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
            }}>{ad.seller||t.userFallback}</span>
            {ad.verified && <span style={{fontSize:9, color:"#34D399", fontWeight:800}}>✓</span>}
          </div>
        )}
      </div>
    </div>
  );
};



// === ContactModal ===
export const ContactModal = ({item,onClose,showToast,navigate,lang = "fr"}) => {
  const t = useLang(lang);
  const [sent,setSent] = useState(false);
  const [sending,setSending] = useState(false);
  const [msg,setMsg] = useState(t.cmGreetingPre + (item?.title||item?.name||"") + t.cmGreetingPost);

  const sendMessage = async () => {
    if (!msg.trim()) {
      showToast({type:"error",text:t.cmErrWriteMsg});
      return;
    }
    setSending(true);
    try {
      const authRes = await supabase.auth.getUser();
      const authUser = authRes.data.user;
      if (!authUser) {
        showToast({type:"error",text:t.cmLoginToSend});
        setSending(false);
        return;
      }

      // Recuperer le user_id du vendeur depuis l annonce
      const { data: adData } = await supabase.from("ads").select("user_id").eq("id", item.id).single();
      if (!adData) {
        showToast({type:"error",text:t.dErrAdNotFound});
        setSending(false);
        return;
      }

      const sellerId = adData.user_id;
      if (sellerId === authUser.id) {
        showToast({type:"error",text:t.cmCantContactSelf});
        setSending(false);
        return;
      }

      // Chercher si une conversation existe deja
      const { data: existing } = await supabase
        .from("conversations")
        .select("id")
        .eq("ad_id", item.id)
        .or("and(user1_id.eq." + authUser.id + ",user2_id.eq." + sellerId + "),and(user1_id.eq." + sellerId + ",user2_id.eq." + authUser.id + ")")
        .limit(1);

      let convId;
      if (existing && existing.length > 0) {
        convId = existing[0].id;
      } else {
        // Creer une nouvelle conversation
        const { data: newConv, error: convErr } = await supabase
          .from("conversations")
          .insert({
            user1_id: authUser.id,
            user2_id: sellerId,
            ad_id: item.id,
            last_message: msg.trim(),
            last_message_at: new Date().toISOString()
          })
          .select()
          .single();

        if (convErr) {
          showToast({type:"error",text:t.cmErrPrefix+convErr.message});
          setSending(false);
          return;
        }
        convId = newConv.id;
      }

      // Envoyer le message
      const { error: msgErr } = await supabase.from("messages").insert({
        conversation_id: convId,
        sender_id: authUser.id,
        content: msg.trim()
      });

      if (msgErr) {
        showToast({type:"error",text:t.cmErrPrefix+msgErr.message});
        setSending(false);
        return;
      }

      // Mettre a jour la conversation
      await supabase.from("conversations").update({
        last_message: msg.trim(),
        last_message_at: new Date().toISOString()
      }).eq("id", convId);

      // Creer une notification pour le destinataire
      try {
        const msgContent = msg.trim();
        await supabase.from("notifications").insert({
          user_id: sellerId,
          type: "message",
          title: "Nouveau message",
          message: msgContent.length > 60 ? msgContent.substring(0, 60) + "..." : msgContent,
          read: false,
          link: "chat:" + convId
        });
      } catch(e) {
        console.error("Notification creation failed:", e);
      }

      setSent(true);
      setTimeout(()=>{ onClose(); if(navigate) navigate("dash"); }, 1800);
    } catch(err) {
      showToast({type:"error",text:t.dErrConnection});
      console.error(err);
    }
    setSending(false);
  };

  return (
    <Modal onClose={onClose}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontFamily:"var(--fh)",fontSize:20,fontWeight:800}}>{t.sendMessage}</div>
        <button onClick={onClose} style={{background:"var(--bg)",border:"none",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
          <CIcon name="close" s={16} c="var(--muted)"/>
        </button>
      </div>
      {sent ? (
        <div style={{textAlign:"center",padding:"20px 0"}}>
          <div style={{width:56,height:56,borderRadius:"50%",background:"rgba(4,120,87,.1)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px"}}>
            <CIcon name="check" s={26} c="#047857" sw={2.5}/>
          </div>
          <div style={{fontFamily:"var(--fh)",fontSize:20,fontWeight:800,marginBottom:6}}>{t.messageSent}</div>
          <div style={{fontSize:13,color:"var(--muted)"}}>{t.cmFindInMessages}</div>
        </div>
      ) : (
        <>
          <div style={{background:"var(--bg)",borderRadius:10,padding:"10px 12px",marginBottom:14,display:"flex",gap:10,alignItems:"center"}}>
            <div style={{width:36,height:36,borderRadius:9,background:CAT_COLOR[item?.cat]||"var(--dark)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <CIcon name={item?.cat||"gear"} s={18} c="#fff"/>
            </div>
            <div>
              <div style={{fontSize:12.5,fontWeight:600,color:"var(--text)"}}>{item?.title||item?.name}</div>
              <div style={{fontSize:11,color:"var(--red)",fontWeight:700}}>{item?.price}</div>
            </div>
          </div>
          <div style={{marginBottom:12}}>
            <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:5}}>{t.cmYourMessage}</div>
            <textarea value={msg} onChange={e=>setMsg(e.target.value)} rows={5}
              style={{width:"100%",padding:"10px 12px",background:"#fff",border:"1.5px solid var(--border)",borderRadius:10,fontSize:13,color:"var(--text)",resize:"none",fontFamily:"var(--fb)"}}/>
          </div>
          <button onClick={sendMessage} disabled={sending} style={{width:"100%",padding:"13px",background:sending?"var(--muted)":"var(--red)",color:"#fff",border:"none",borderRadius:11,fontSize:14,fontWeight:700,cursor:sending?"default":"pointer",fontFamily:"var(--fh)",letterSpacing:.5,textTransform:"uppercase",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
            {sending ? t.dSending : (<><CIcon name="send" s={16} c="#fff"/>{t.sendBtn}</>)}
          </button>
          <div style={{fontSize:11,color:"var(--muted)",textAlign:"center",marginTop:10,lineHeight:1.5}}>{t.cmConvCreated}</div>
        </>
      )}
    </Modal>
  );
};



// === PasswordStrength ===
export function PasswordStrength({ pwd }) {
  if (!pwd) return null;
  const v = validatePassword(pwd);
  const colors = ["#ef4444", "#f97316", "#eab308", "#84cc16", "#10b981"];
  const labels = ["Tres faible", "Faible", "Moyen", "Fort", "Tres fort"];
  const color = colors[Math.max(0, v.score - 1)];
  const label = labels[Math.max(0, v.score - 1)];
  return (
    <div style={{marginTop:8,padding:"10px 12px",background:"var(--bg)",borderRadius:8,border:"1px solid var(--border)"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
        <div style={{display:"flex",gap:3,flex:1}}>
          {[1,2,3,4,5].map(i=>(
            <div key={i} style={{flex:1,height:4,borderRadius:2,background:i<=v.score?color:"rgba(0,0,0,.08)",transition:"all .2s"}}/>
          ))}
        </div>
        <div style={{fontSize:10,fontWeight:700,color:color,marginLeft:10,minWidth:60,textAlign:"right"}}>{label}</div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:4,fontSize:10}}>
        <div style={{color:v.length?"#10b981":"var(--muted)"}}>{v.length?"v":"o"} 8 caracteres min</div>
        <div style={{color:v.upper?"#10b981":"var(--muted)"}}>{v.upper?"v":"o"} Majuscule</div>
        <div style={{color:v.lower?"#10b981":"var(--muted)"}}>{v.lower?"v":"o"} Minuscule</div>
        <div style={{color:v.digit?"#10b981":"var(--muted)"}}>{v.digit?"v":"o"} Chiffre</div>
        <div style={{color:v.special?"#10b981":"var(--muted)",gridColumn:"span 2"}}>{v.special?"v":"o"} Caractere special</div>
      </div>
    </div>
  );
}


// === NotificationBell ===
export function NotificationBell({ onClick }) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let channel = null;
    const init = async () => {
      const authRes = await supabase.auth.getUser();
      const user = authRes.data.user;
      if (!user) return;
      
      // Charger le compte de notifications non lues
      const loadCount = async () => {
        const { count } = await supabase
          .from("notifications")
          .select("*", { count: "exact", head: true })
          .eq("user_id", user.id)
          .eq("read", false);
        setUnread(count || 0);
      };
      loadCount();
      
      // Listener real-time
      channel = supabase
        .channel("notifications-bell-" + user.id)
        .on("postgres_changes", { 
          event: "*", 
          schema: "public", 
          table: "notifications",
          filter: "user_id=eq." + user.id
        }, () => {
          loadCount();
        })
        .subscribe();
    };
    init();
    // Le realtime n'est pas activé sur `notifications` -> l'écran des notifs nous
    // prévient quand il a tout marqué lu, pour vider la pastille sans rechargement.
    const onSeen = () => setUnread(0);
    window.addEventListener("hc:notifs-read", onSeen);
    return () => { if (channel) supabase.removeChannel(channel); window.removeEventListener("hc:notifs-read", onSeen); };
  }, []);

  return (
    <button onClick={onClick} style={{position:"relative",background:"var(--bg)",border:"1.5px solid var(--border)",borderRadius:20,padding:"5px 11px",cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
      <CIcon name="bell" s={13} c="var(--dark)"/>
      {unread > 0 && (
        <span style={{position:"absolute",top:-4,right:-4,minWidth:18,height:18,padding:"0 5px",background:"var(--red)",color:"#fff",borderRadius:9,fontSize:9,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center",border:"2px solid #fff"}}>
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}



// === PhotoGallery ===
export function PhotoGallery({ photos = [], onClose }) {
  const [index, setIndex] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [touchStart, setTouchStart] = useState(null);

  if (!photos || photos.length === 0) return null;

  const next = () => setIndex(i => (i + 1) % photos.length);
  const prev = () => setIndex(i => (i - 1 + photos.length) % photos.length);

  const handleTouchStart = (e) => {
    if (zoom) return;
    setTouchStart(e.touches[0].clientX);
  };
  const handleTouchEnd = (e) => {
    if (!touchStart || zoom) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();
      else prev();
    }
    setTouchStart(null);
  };

  return (
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,.95)",zIndex:9999,display:"flex",flexDirection:"column"}}>
      {/* Header */}
      <div style={{padding:"40px 16px 12px",display:"flex",justifyContent:"space-between",alignItems:"center",color:"#fff"}}>
        <button onClick={onClose} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:"50%",width:36,height:36,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff",fontSize:20}}>×</button>
        <div style={{fontSize:14,fontWeight:600}}>{index + 1} / {photos.length}</div>
        <button onClick={()=>setZoom(!zoom)} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:"50%",width:36,height:36,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff",fontSize:18}}>{zoom?"−":"+"}</button>
      </div>
      
      {/* Image */}
      <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",overflow:"hidden",position:"relative"}}
           onTouchStart={handleTouchStart}
           onTouchEnd={handleTouchEnd}>
        <img 
          src={photos[index]} 
          alt={`Photo ${index + 1}`}
          style={{
            maxWidth: zoom ? "none" : "100%",
            maxHeight: zoom ? "none" : "100%",
            width: zoom ? "200%" : "auto",
            objectFit: "contain",
            transition: "all .2s",
            cursor: zoom ? "zoom-out" : "zoom-in"
          }}
          onClick={()=>setZoom(!zoom)}
        />
        
        {/* Boutons prev/next */}
        {photos.length > 1 && !zoom && (
          <>
            <button onClick={prev} style={{position:"absolute",left:8,top:"50%",transform:"translateY(-50%)",background:"rgba(255,255,255,.2)",border:"none",borderRadius:"50%",width:44,height:44,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff",fontSize:24}}>‹</button>
            <button onClick={next} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"rgba(255,255,255,.2)",border:"none",borderRadius:"50%",width:44,height:44,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff",fontSize:24}}>›</button>
          </>
        )}
      </div>

      {/* Thumbnails */}
      {photos.length > 1 && (
        <div style={{padding:"12px 16px 24px",display:"flex",gap:6,overflowX:"auto"}}>
          {photos.map((p, i) => (
            <div key={i} onClick={()=>setIndex(i)} style={{flexShrink:0,width:54,height:54,borderRadius:8,backgroundImage:`url(${p})`,backgroundSize:"cover",backgroundPosition:"center",cursor:"pointer",border:i===index?"2.5px solid #C8001A":"2.5px solid transparent",opacity:i===index?1:0.6,transition:"all .2s"}}/>
          ))}
        </div>
      )}
    </div>
  );
}



// === DashboardStats ===
export function DashboardStats({ user }) {
  const [stats, setStats] = useState({
    activeAds: 0,
    totalViews: 0,
    favoritesReceived: 0,
    messagesReceived: 0,
    memberSince: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const authRes = await supabase.auth.getUser();
      const authUser = authRes.data.user;
      if (!authUser) { setLoading(false); return; }

      // Charger les annonces de l'utilisateur
      const adsRes = await supabase
        .from("ads")
        .select("id, views, status, created_at")
        .eq("user_id", authUser.id);
      
      const ads = adsRes.data || [];
      const adIds = ads.map(a => a.id);
      const activeAds = ads.filter(a => a.status === "active").length;
      const totalViews = ads.reduce((sum, a) => sum + (a.views || 0), 0);

      // Charger les favoris reçus
      let favoritesReceived = 0;
      if (adIds.length > 0) {
        const favRes = await supabase
          .from("favorites")
          .select("id", { count: "exact", head: true })
          .in("ad_id", adIds);
        favoritesReceived = favRes.count || 0;
      }

      // Charger les messages reçus
      let messagesReceived = 0;
      const convRes = await supabase
        .from("conversations")
        .select("id")
        .or(`user1_id.eq.${authUser.id},user2_id.eq.${authUser.id}`);
      
      if (convRes.data && convRes.data.length > 0) {
        const convIds = convRes.data.map(c => c.id);
        const msgRes = await supabase
          .from("messages")
          .select("id", { count: "exact", head: true })
          .in("conversation_id", convIds)
          .neq("sender_id", authUser.id);
        messagesReceived = msgRes.count || 0;
      }

      // Date d'inscription
      const profileRes = await supabase
        .from("profiles")
        .select("created_at, member_since")
        .eq("id", authUser.id)
        .single();
      const memberSince = profileRes.data?.member_since || profileRes.data?.created_at;

      setStats({ activeAds, totalViews, favoritesReceived, messagesReceived, memberSince });
    } catch(err) {
      console.error("Erreur stats:", err);
    }
    setLoading(false);
  };

  const StatCard = ({icon, label, value, color}) => (
    <div style={{flex:1,minWidth:0,background:"#fff",borderRadius:12,padding:"12px 10px",textAlign:"center",border:"1px solid var(--border)"}}>
      <div style={{fontSize:22,marginBottom:4}}>{icon}</div>
      <div style={{fontFamily:"var(--fh)",fontSize:20,fontWeight:800,color:color||"var(--text)",lineHeight:1}}>{value}</div>
      <div style={{fontSize:9,fontWeight:700,color:"var(--muted)",letterSpacing:.5,textTransform:"uppercase",marginTop:3}}>{label}</div>
    </div>
  );

  const formatDate = (date) => {
    if (!date) return "—";
    const d = new Date(date);
    const months = ["jan","fev","mar","avr","mai","juin","juil","aout","sept","oct","nov","dec"];
    return months[d.getMonth()] + " " + d.getFullYear();
  };

  if (loading) {
    return (
      <div style={{padding:"20px 16px",background:"#fff",borderRadius:14,margin:"12px 0"}}>
        <div style={{textAlign:"center",color:"var(--muted)",fontSize:12}}>Chargement des stats...</div>
      </div>
    );
  }

  return (
    <div style={{padding:"14px 0"}}>
      <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:8,paddingLeft:2}}>📊 Mes statistiques</div>
      <div style={{display:"flex",gap:6,marginBottom:8}}>
        <StatCard icon="📋" label="Annonces" value={stats.activeAds} color="var(--red)"/>
        <StatCard icon="👀" label="Vues" value={stats.totalViews} color="var(--dark)"/>
        <StatCard icon="♥" label="Favoris" value={stats.favoritesReceived} color="var(--red)"/>
        <StatCard icon="💬" label="Messages" value={stats.messagesReceived} color="var(--dark)"/>
      </div>
      {stats.memberSince && (
        <div style={{fontSize:11,color:"var(--muted)",textAlign:"center",fontWeight:600}}>
          Membre depuis {formatDate(stats.memberSince)}
        </div>
      )}
    </div>
  );
}



// === SearchAdvancedModal ===
export function SearchAdvancedModal({onClose,onApply,initialFilters={},lang = "fr"}) {
  const t = useLang(lang);
  const [priceMin,setPriceMin]=useState(initialFilters.priceMin||"");
  const [priceMax,setPriceMax]=useState(initialFilters.priceMax||"");
  const [country,setCountry]=useState(initialFilters.country||"");
  const [region,setRegion]=useState(initialFilters.region||"");
  const [note,setNote]=useState(initialFilters.note||0);
  const [verifOnly,setVerifOnly]=useState(initialFilters.verifOnly||false);
  const [boxDispo,setBoxDispo]=useState(initialFilters.boxDispo||false);
  const [kidsOnly,setKidsOnly]=useState(initialFilters.kidsOnly||false);
  const [sortBy,setSortBy]=useState(initialFilters.sortBy||"recent");
  const [horseBreed,setHorseBreed]=useState(initialFilters.horseBreed||"");
  const [horseSex,setHorseSex]=useState(initialFilters.horseSex||"");
  const [horseAgeRange,setHorseAgeRange]=useState(initialFilters.horseAgeRange||"");
  const [horseLevel,setHorseLevel]=useState(initialFilters.horseLevel||"");
  const [horseDiscipline,setHorseDiscipline]=useState(initialFilters.horseDiscipline||"");
  const [showHorseFilters,setShowHorseFilters]=useState(false);

  const apply=()=>{
    onApply({priceMin,priceMax,country,region,note,verifOnly,boxDispo,kidsOnly,sortBy,horseBreed,horseSex,horseAgeRange,horseLevel,horseDiscipline});
    onClose();
  };

  const reset=()=>{
    setPriceMin("");setPriceMax("");setCountry("");setRegion("");
    setNote(0);setVerifOnly(false);setBoxDispo(false);setKidsOnly(false);setSortBy("recent");
    setHorseBreed("");setHorseSex("");setHorseAgeRange("");setHorseLevel("");setHorseDiscipline("");
  };
  return (
    <Modal onClose={onClose}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontFamily:"var(--fh)",fontSize:20,fontWeight:800}}>{t.samTitle}</div>
        <button onClick={onClose} style={{background:"var(--bg)",border:"none",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}><CIcon name="close" s={16} c="var(--muted)"/></button>
      </div>
      {/* Prix */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>{t.samPriceRange}</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <Field placeholder={t.samMin} value={priceMin} onChange={e=>setPriceMin(e.target.value)} icon="star"/>
          <Field placeholder={t.samMax} value={priceMax} onChange={e=>setPriceMax(e.target.value)} icon="star"/>
        </div>
      </div>
      {/* Pays et région */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>{t.dLocationSection}</div>
        <div style={{display:"flex",gap:8,marginBottom:8}}>
          <select value={country} onChange={e=>{setCountry(e.target.value);setRegion("");}} style={{flex:1,padding:"10px",border:"1px solid var(--border)",borderRadius:8,fontSize:13,background:"#fff",fontFamily:"var(--fb)"}}>
            <option value="">{t.dAllCountries}</option>
            {COUNTRIES.map(c=><option key={c.code} value={c.code}>{c.flag} {c.name}</option>)}
          </select>
          <select value={region} onChange={e=>setRegion(e.target.value)} disabled={!country} style={{flex:1.5,padding:"10px",border:"1px solid var(--border)",borderRadius:8,fontSize:13,background:country?"#fff":"var(--bg)",fontFamily:"var(--fb)",opacity:country?1:0.5}}>
            <option value="">{t.samAllRegions}</option>
            {country && (COUNTRIES.find(c=>c.code===country)?.regions||[]).map(r=><option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      </div>

      {/* Tri */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>{t.samSortBy}</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:6}}>
          {[
            {val:"recent",label:t.samSortRecent},
            {val:"price_asc",label:t.samSortPriceAsc},
            {val:"price_desc",label:t.samSortPriceDesc},
            {val:"popular",label:t.samSortPopular}
          ].map(opt=>(
            <button key={opt.val} onClick={()=>setSortBy(opt.val)} style={{background:sortBy===opt.val?"var(--red)":"var(--bg)",color:sortBy===opt.val?"#fff":"var(--muted)",border:`1.5px solid ${sortBy===opt.val?"var(--red)":"var(--border)"}`,borderRadius:8,padding:"7px 10px",fontSize:11,fontFamily:"var(--fh)",fontWeight:700,cursor:"pointer"}}>{opt.label}</button>
          ))}
        </div>
      </div>
      {/* Note min */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>{t.samMinRating}</div>
        <div style={{display:"flex",gap:6}}>
          {[0,3,4,4.5].map(n=>(
            <button key={n} onClick={()=>setNote(n)} style={{background:note===n?"var(--red)":"var(--bg)",color:note===n?"#fff":"var(--muted)",border:`1.5px solid ${note===n?"var(--red)":"var(--border)"}`,borderRadius:20,padding:"5px 12px",fontSize:11,fontFamily:"var(--fh)",fontWeight:700,cursor:"pointer",flex:1}}>
              {n===0?t.samAllRatings:`${n}★+`}
            </button>
          ))}
        </div>
      </div>
      {/* Filtres chevaux */}
      <div style={{marginBottom:14,paddingTop:6,borderTop:"1px dashed var(--border)"}}>
        <button type="button" onClick={()=>setShowHorseFilters(!showHorseFilters)} style={{width:"100%",padding:"8px",background:"transparent",border:"none",fontSize:11,fontWeight:700,color:"var(--text)",letterSpacing:.5,textTransform:"uppercase",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>{t.samHorseFilters}</span>
          <span style={{transform:showHorseFilters?"rotate(180deg)":"none",transition:"transform .2s"}}>▼</span>
        </button>
        {showHorseFilters && (
          <div style={{paddingTop:8,display:"flex",flexDirection:"column",gap:10}}>
            {/* Race */}
            <div>
              <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1,marginBottom:4}}>{t.dRace}</div>
              <select value={horseBreed} onChange={e=>setHorseBreed(e.target.value)} style={{width:"100%",padding:"8px",border:"1px solid var(--border)",borderRadius:8,fontSize:12,background:"#fff"}}>
                <option value="">{t.samAllRaces}</option>
                {HORSE_BREEDS.map(b=><option key={b} value={b}>{b}</option>)}
              </select>
            </div>
            
            {/* Sexe */}
            <div>
              <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1,marginBottom:4}}>{t.dSex}</div>
              <div style={{display:"flex",gap:5}}>
                <button type="button" onClick={()=>setHorseSex("")} style={{flex:1,padding:"6px",background:!horseSex?"var(--red)":"var(--bg)",color:!horseSex?"#fff":"var(--muted)",border:`1.5px solid ${!horseSex?"var(--red)":"var(--border)"}`,borderRadius:8,fontSize:10,fontWeight:700,cursor:"pointer"}}>{t.samAllMasc}</button>
                {HORSE_SEX.map(s=>(
                  <button key={s.val} type="button" onClick={()=>setHorseSex(s.val)} style={{flex:1,padding:"6px",background:horseSex===s.val?"var(--red)":"var(--bg)",color:horseSex===s.val?"#fff":"var(--muted)",border:`1.5px solid ${horseSex===s.val?"var(--red)":"var(--border)"}`,borderRadius:8,fontSize:10,fontWeight:700,cursor:"pointer"}}>{s.label}</button>
                ))}
              </div>
            </div>
            
            {/* Âge */}
            <div>
              <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1,marginBottom:4}}>{t.dAgeRange}</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:5}}>
                <button type="button" onClick={()=>setHorseAgeRange("")} style={{padding:"6px",background:!horseAgeRange?"var(--red)":"var(--bg)",color:!horseAgeRange?"#fff":"var(--muted)",border:`1.5px solid ${!horseAgeRange?"var(--red)":"var(--border)"}`,borderRadius:8,fontSize:10,fontWeight:700,cursor:"pointer"}}>{t.samAllAges}</button>
                {HORSE_AGE_RANGES.map(a=>(
                  <button key={a.val} type="button" onClick={()=>setHorseAgeRange(a.val)} style={{padding:"6px",background:horseAgeRange===a.val?"var(--red)":"var(--bg)",color:horseAgeRange===a.val?"#fff":"var(--muted)",border:`1.5px solid ${horseAgeRange===a.val?"var(--red)":"var(--border)"}`,borderRadius:8,fontSize:10,fontWeight:700,cursor:"pointer"}}>{a.label}</button>
                ))}
              </div>
            </div>
            
            {/* Niveau */}
            <div>
              <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1,marginBottom:4}}>{t.dLevel}</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5}}>
                <button type="button" onClick={()=>setHorseLevel("")} style={{padding:"6px",background:!horseLevel?"var(--red)":"var(--bg)",color:!horseLevel?"#fff":"var(--muted)",border:`1.5px solid ${!horseLevel?"var(--red)":"var(--border)"}`,borderRadius:8,fontSize:10,fontWeight:700,cursor:"pointer"}}>{t.samAllMasc}</button>
                {HORSE_LEVELS.map(l=>(
                  <button key={l.val} type="button" onClick={()=>setHorseLevel(l.val)} style={{padding:"6px",background:horseLevel===l.val?"var(--red)":"var(--bg)",color:horseLevel===l.val?"#fff":"var(--muted)",border:`1.5px solid ${horseLevel===l.val?"var(--red)":"var(--border)"}`,borderRadius:8,fontSize:10,fontWeight:700,cursor:"pointer"}}>{l.label}</button>
                ))}
              </div>
            </div>
            
            {/* Discipline */}
            <div>
              <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1,marginBottom:4}}>{t.samDiscipline}</div>
              <select value={horseDiscipline} onChange={e=>setHorseDiscipline(e.target.value)} style={{width:"100%",padding:"8px",border:"1px solid var(--border)",borderRadius:8,fontSize:12,background:"#fff"}}>
                <option value="">{t.samAllDisciplines}</option>
                {HORSE_DISCIPLINES.map(d=><option key={d} value={d}>{d}</option>)}
              </select>
            </div>
          </div>
        )}
      </div>
      <div style={{marginBottom:10}}>
        <Chk on={verifOnly} toggle={()=>setVerifOnly(!verifOnly)} label={t.samVerifOnly}/>
      </div>
      <div style={{marginBottom:10}}>
        <Chk on={boxDispo} toggle={()=>setBoxDispo(!boxDispo)} label={t.samBoxOnly}/>
      </div>
      <div style={{marginBottom:18}}>
        <Chk on={kidsOnly} toggle={()=>setKidsOnly(!kidsOnly)} label={t.samKidsOnly}/>
      </div>
      <div style={{display:"flex",gap:8}}>
        <Btn ghost onClick={reset} sx={{flex:1}}>{t.samReset}</Btn>
        <Btn onClick={apply} sx={{flex:2}}>{t.samApply}</Btn>
      </div>
    </Modal>
  );
}



// === ReportModal ===
// Signale soit une annonce (item.id → ad_id), soit un trajet HorseRoad
// (tripId → trip_id), soit une randonnée (trailId → trail_id), soit un
// utilisateur directement (reportedUserId). Les 4 modes sont mutuellement
// exclusifs côté insert.
export function ReportModal({item,reportedUserId=null,tripId=null,trailId=null,onClose,showToast,lang = "fr"}) {
  const t = useLang(lang);
  const [reason,setReason]=useState("");
  const [detail,setDetail]=useState("");
  // i18n inline (évite d'alourdir constants.js) : titres "trajet"/"randonnée"
  // + motifs spécifiques au signalement d'un utilisateur ou d'un tracé.
  const RM = {
    fr:{trip:"Signaler ce trajet", uHarass:"Harcèlement ou menaces", uScam:"Arnaque ou fraude", uFake:"Faux profil / usurpation", uContent:"Contenu inapproprié", uOther:"Autre",
      trail:"Signaler ce tracé", trailIntro:"Merci ! Ton retour du terrain aide les autres cavaliers. Un tracé signalé plusieurs fois est vérifié puis retiré.", tClosed:"Chemin fermé, barré ou disparu", tDanger:"Dangereux (falaise, route, terrain…)", tForbidden:"Interdit aux chevaux", tPrivate:"Passage privé, pas d'autorisation", tWrong:"Tracé faux ou inutilisable", tOther:"Autre"},
    en:{trip:"Report this trip", uHarass:"Harassment or threats", uScam:"Scam or fraud", uFake:"Fake profile / impersonation", uContent:"Inappropriate content", uOther:"Other",
      trail:"Report this route", trailIntro:"Thanks! Your feedback from the field helps other riders. A route reported several times is checked, then removed.", tClosed:"Path closed, blocked or gone", tDanger:"Dangerous (cliff, road, terrain…)", tForbidden:"Horses not allowed", tPrivate:"Private land, no permission", tWrong:"Wrong or unusable track", tOther:"Other"},
    de:{trip:"Diese Fahrt melden", uHarass:"Belästigung oder Drohungen", uScam:"Betrug", uFake:"Fake-Profil / Identitätsdiebstahl", uContent:"Unangemessener Inhalt", uOther:"Andere",
      trail:"Diese Route melden", trailIntro:"Danke! Dein Feedback vom Gelände hilft anderen Reitern. Eine mehrfach gemeldete Route wird geprüft und dann entfernt.", tClosed:"Weg gesperrt, versperrt oder verschwunden", tDanger:"Gefährlich (Abhang, Straße, Gelände…)", tForbidden:"Für Pferde verboten", tPrivate:"Privatgrund, keine Erlaubnis", tWrong:"Route falsch oder unbrauchbar", tOther:"Andere"},
    es:{trip:"Denunciar este trayecto", uHarass:"Acoso o amenazas", uScam:"Estafa o fraude", uFake:"Perfil falso / suplantación", uContent:"Contenido inapropiado", uOther:"Otro",
      trail:"Denunciar esta ruta", trailIntro:"¡Gracias! Tu experiencia sobre el terreno ayuda a otros jinetes. Una ruta denunciada varias veces se verifica y se retira.", tClosed:"Camino cerrado, cortado o desaparecido", tDanger:"Peligroso (precipicio, carretera, terreno…)", tForbidden:"Prohibido a los caballos", tPrivate:"Paso privado, sin autorización", tWrong:"Trazado falso o inutilizable", tOther:"Otro"},
    it:{trip:"Segnala questo tragitto", uHarass:"Molestie o minacce", uScam:"Truffa o frode", uFake:"Profilo falso / furto d'identità", uContent:"Contenuto inappropriato", uOther:"Altro",
      trail:"Segnala questo percorso", trailIntro:"Grazie! La tua esperienza sul campo aiuta gli altri cavalieri. Un percorso segnalato più volte viene verificato e poi rimosso.", tClosed:"Sentiero chiuso, sbarrato o scomparso", tDanger:"Pericoloso (dirupo, strada, terreno…)", tForbidden:"Vietato ai cavalli", tPrivate:"Passaggio privato, senza autorizzazione", tWrong:"Tracciato errato o inutilizzabile", tOther:"Altro"},
    pt:{trip:"Denunciar este trajeto", uHarass:"Assédio ou ameaças", uScam:"Burla ou fraude", uFake:"Perfil falso / usurpação", uContent:"Conteúdo inadequado", uOther:"Outro",
      trail:"Denunciar este itinerário", trailIntro:"Obrigado! A tua experiência no terreno ajuda os outros cavaleiros. Um itinerário denunciado várias vezes é verificado e depois retirado.", tClosed:"Caminho fechado, cortado ou desaparecido", tDanger:"Perigoso (precipício, estrada, terreno…)", tForbidden:"Proibido a cavalos", tPrivate:"Passagem privada, sem autorização", tWrong:"Traçado errado ou inutilizável", tOther:"Outro"},
    nl:{trip:"Deze rit rapporteren", uHarass:"Pesterijen of bedreigingen", uScam:"Oplichting of fraude", uFake:"Vals profiel / identiteitsmisbruik", uContent:"Ongepaste inhoud", uOther:"Andere",
      trail:"Deze route rapporteren", trailIntro:"Bedankt! Je ervaring in het veld helpt andere ruiters. Een route die meermaals gerapporteerd wordt, wordt nagekeken en dan verwijderd.", tClosed:"Pad afgesloten, versperd of verdwenen", tDanger:"Gevaarlijk (afgrond, weg, terrein…)", tForbidden:"Verboden voor paarden", tPrivate:"Privédomein, geen toestemming", tWrong:"Route fout of onbruikbaar", tOther:"Andere"},
  };
  const L = RM[lang] || RM.fr;
  // val = valeur canonique stockee en BD (ne pas traduire) ; label = affichage traduit
  const adReasons=[
    {val:"Annonce frauduleuse",label:t.rmReasonFraud},
    {val:"Prix abusif",label:t.rmReasonPrice},
    {val:"Photos non conformes",label:t.rmReasonPhotos},
    {val:"Informations incorrectes",label:t.rmReasonInfo},
    {val:"Contenu inapproprié",label:t.rmReasonContent},
    {val:"Animal maltraité",label:t.rmReasonAnimal},
    {val:"Autre",label:t.rmReasonOther},
  ];
  const userReasons=[
    {val:"Harcèlement ou menaces",label:L.uHarass},
    {val:"Arnaque ou fraude",label:L.uScam},
    {val:"Faux profil / usurpation",label:L.uFake},
    {val:"Contenu inapproprié",label:L.uContent},
    {val:"Autre",label:L.uOther},
  ];
  const trailReasons=[
    {val:"Chemin fermé ou disparu",label:L.tClosed},
    {val:"Dangereux",label:L.tDanger},
    {val:"Interdit aux chevaux",label:L.tForbidden},
    {val:"Passage privé",label:L.tPrivate},
    {val:"Tracé faux",label:L.tWrong},
    {val:"Autre",label:L.tOther},
  ];
  const reasons = reportedUserId ? userReasons : (trailId ? trailReasons : adReasons);
  const title = reportedUserId ? t.reportUser : (tripId ? L.trip : (trailId ? L.trail : t.reportAd));
  const intro = trailId ? L.trailIntro : t.rmIntro;
  return (
    <Modal onClose={onClose}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div style={{fontFamily:"var(--fh)",fontSize:18,fontWeight:800,color:"var(--red)"}}>{title}</div>
        <button onClick={onClose} style={{background:"var(--bg)",border:"none",borderRadius:"50%",width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}><CIcon name="close" s={16} c="var(--muted)"/></button>
      </div>
      <div style={{fontSize:12.5,color:"var(--muted)",marginBottom:14,lineHeight:1.5}}>{intro}</div>
      <div style={{marginBottom:12}}>
        <div style={{fontSize:10,fontWeight:700,color:"var(--muted)",letterSpacing:1.5,textTransform:"uppercase",marginBottom:8}}>{t.reportReason}</div>
        {reasons.map(r=>(
          <div key={r.val} onClick={()=>setReason(r.val)} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 12px",borderRadius:9,background:reason===r.val?"rgba(200,0,26,.06)":"transparent",cursor:"pointer",marginBottom:2}}>
            <div style={{width:18,height:18,borderRadius:"50%",border:`2px solid ${reason===r.val?"var(--red)":"var(--border)"}`,background:reason===r.val?"var(--red)":"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              {reason===r.val&&<div style={{width:6,height:6,borderRadius:"50%",background:"#fff"}}/>}
            </div>
            <span style={{fontSize:13,color:"var(--text)"}}>{r.label}</span>
          </div>
        ))}
      </div>
      <div style={{marginBottom:14}}>
        <Field label={t.rmDetailLabel} placeholder={t.rmDetailPh} rows={3} value={detail} onChange={e=>setDetail(e.target.value)}/>
      </div>
      <div style={{display:"flex",gap:9}}>
        <Btn ghost onClick={onClose} sx={{flex:1}}>{t.cancel}</Btn>
        <Btn onClick={async ()=>{
          if(!reason){showToast({type:"error",text:t.rmChooseReason});return;}
          try {
            const authRes = await supabase.auth.getUser();
            const authUser = authRes.data.user;
            if (!authUser) {
              showToast({type:"error",text:t.rmLoginToReport});
              return;
            }
            const { error } = await supabase.from("reports").insert({
              reporter_id: authUser.id,
              ad_id: (reportedUserId || tripId || trailId) ? null : (item?.id || null),
              trip_id: tripId || null,
              trail_id: trailId || null,
              user_reported_id: reportedUserId || null,
              reason: reason,
              details: detail || null,
              status: "pending"
            });
            if (error) {
              showToast({type:"error",text:t.cmErrPrefix+error.message});
              return;
            }
            showToast({type:"success",text:t.rmReportSent});
            onClose();
          } catch(err) {
            showToast({type:"error",text:t.dErrConnection});
            console.error(err);
          }
        }} sx={{flex:2,background:"var(--red)"}}>{t.sendReport}</Btn>
      </div>
    </Modal>
  );
}

// === InstallAppPopup ===
// Tutoriel pour installer l'app sur l'ecran d'accueil
// ============================================================
//  TRADUCTIONS i18n - InstallAppPopup & CookieBanner
//  (inline pour éviter de modifier constants.js)
// ============================================================


// === Ré-exports depuis ui-popups.jsx ===
// InstallAppPopup et CookieBanner ont été extraits dans
// ui-popups.jsx pour réduire ui.jsx (qui faisait 2134 lignes).
// On les ré-exporte ici pour ne pas casser les imports
// existants `import { InstallAppPopup } from "./ui"`.
export { InstallAppPopup, CookieBanner } from "./ui-popups";
